@for (field of fields; track field) { @switch (field.type) {
<!-- Text Input -->
@case (FormControlType.INPUT) {
<mat-form-field class="fill" appearance="outline">
  <mat-label>{{ field.label }}</mat-label>
  <input
    matInput
    [formControl]="field.formControl"
  />
  @if (field.formControl.hasError('required') || field.formControl.hasError('pattern')) {
  <mat-error> This field is required </mat-error>
  }
</mat-form-field>
}
<!-- Email Input -->
@case (FormControlType.EMAIL) {
<mat-form-field class="fill" appearance="outline">
  <mat-label>{{ field.label }}</mat-label>
  <input
    matInput
    type="email"
    [formControl]="field.formControl"
  />
  @if (field.formControl.hasError('required') || field.formControl.hasError('pattern')) {
  <mat-error> This field is required </mat-error>
  } @else if (field.formControl.hasError('invalidEmail')) {
  <mat-error> Email is invalid </mat-error>
  }
</mat-form-field>
}
<!-- Phone Input -->
@case (FormControlType.PHONE) {
<app-phone-input
  class="phone-field"
  [formControl]="field.formControl"
  [label]="field.label"
  [required]="field.required"
></app-phone-input>
}
<!-- Select Input -->
@case (FormControlType.SELECT) {
<mat-form-field class="fill" appearance="outline">
  <mat-label>{{ field.label }}</mat-label>
  <mat-select [formControl]="field.formControl">
    @for (option of field.config?.options; track option) {
    <mat-option [value]="option.value">
      {{ option.text }}
    </mat-option>
    }
  </mat-select>
  @if (field.formControl.hasError('required')) {
  <mat-error> This field is required </mat-error>
  }
</mat-form-field>
} } }
